
export default {
  async authenticate({state,dispatch, commit},returnPath) {
    await state.mgr.removeUser()
    const userRequest = await dispatch('getUser'); //see if the user details are in local storage
    if (userRequest) {
      commit('userAuthenticated',userRequest);
    } else {
      await dispatch('signIn',returnPath)
    }
  },
  async getUser ({state}) {
    try {
      let userRequest = await state.mgr.getUser();
      return userRequest;
    } catch (err) {
      return;
    }
  },
  signIn ({state},returnPath) {
    returnPath ? state.mgr.signinRedirect({ status: returnPath })
    : state.mgr.signinRedirect();
  },
  async signinRedirectCallback({state}){
    state.user = await state.mgr.signinRedirectCallback();
    state.isAuthenticated = true
    return state.user;
  },
  async signOut({state}){
    await state.mgr.signoutRedirect()
    state.role= ''
  },
  async clearUserCredentials({state}){
    state.user = undefined
  },

  triggerDetailsDrawer({commit}, payload){
    commit('setDisplayDrawer', payload.displayDrawer)
    commit('setDetailedProject', payload.detailedProject)
    commit('setProjectRaw', payload.projectRaw)
  },
  
  setOnDialog({commit}, payload){
    commit('setAuditDialog', payload.audit)
    commit('setIsLegalAudit', payload.isLegalAudit)
    commit('setAuditResult', payload.result)
    commit('setAuditProject', payload.project)
  },

  snackAlert({commit}, success){
    if(success)
      commit('setSnackText', "operationCompleted")
    else
      commit('setSnackText', "someWrong")
    commit('setSnackBar', true)
    
  },
  snackUserAlert({commit}, success){
    if(success)
      commit('setSnackText', "operationCompleted")
    else
      commit('setSnackText', "createUserWrong")
    commit('setSnackBar', true)
    
  },
  noCameraAlert({commit}, alert){
    commit('setSnackText', alert)
    commit('setSnackBar', true)
  },
  //snackDownload: true, selected: this.selected, project: this.project, downloadInProgress: true
  startDownloads({commit}, payload){
    commit('setSnackDownload', payload.snackDownload)
    commit('setSelected', payload.selected)
    commit('setProjectDownload', payload.project)
    commit('setDownloadInProgress', payload.downloadInProgress)
  },
  downloadsSetupFinished({commit}){
    commit('setDownloadInProgress', false)
    commit('setSnackDownload', false)
    
  },
  accessDenied({commit},parameter){
    commit('setSnackParameter', {section: parameter})
    commit('setSnackText', 'accessDenied')
    commit('setSnackBar', true)
  }
  
}